import React from 'react';
import "../../css/Legal.css";



const PrivacyPolicy = () => {

    return (

        <>

            <div className="legal-container">
                <p className="legal-title"><strong>Privacy Policy</strong></p>
                <p> <strong>Last Updated:</strong> 25<sup>th</sup> July 2025,</p>
                <p>This Privacy Policy ("<strong>Policy</strong>") explains how <strong>Craft My Store</strong> (“<strong>we</strong>”, “<strong>us</strong>”, or “<strong>our</strong>”) collects, uses, stores, discloses, and protects your personal information when you use our website (<strong>craftmystore.com</strong>), products, or services (collectively, the "<strong>Platform</strong>").</p>
                <p>By accessing or using the Platform, you agree to this Privacy Policy and give your consent to the collection and use of information as outlined below.</p>
                <p><strong>1. Information We Collect</strong></p>
                <p>We may collect the following types of personal and non-personal information:</p>
                <p><strong>1.1 Personal Identifiable Information (PII)</strong></p>
                <ul type="disc">
                    <li><strong>Full Name</strong></li>
                    <li><strong>Email Address</strong></li>
                    <li><strong>Phone Number</strong></li>
                    <li><strong>Billing and Shipping Address</strong></li>
                    <li><strong>Company Name</strong></li>
                    <li><strong>GST Number</strong>&nbsp;(if applicable)</li>
                    <li><strong>Payment Information</strong>&nbsp;(processed via third-party gateways, not stored on our servers)</li>
                    <li><strong>Login Credentials</strong>&nbsp;(if you create an account)</li>
                </ul>
                <p><strong>1.2 Website Usage &amp; Technical Data</strong></p>
                <ul type="disc">
                    <li>IP Address</li>
                    <li>Browser Type and Version</li>
                    <li>Operating System</li>
                    <li>Device Type</li>
                    <li>Referral URL</li>
                    <li>Time and Duration of Visit</li>
                    <li>Pages Visited</li>
                </ul>
                <p><strong>1.3 Communications</strong></p>
                <ul type="disc">
                    <li>Emails, chats, and other communications exchanged with us via our website, WhatsApp, or other support channels.</li>
                </ul>
                <p><strong>2. How We Collect Information</strong></p>
                <p>We collect information via:</p>
                <ul type="disc">
                    <li>Direct forms on our website (e.g., Get Started, Contact Us)</li>
                    <li>Emails and support tickets</li>
                    <li>Order placement and account registration</li>
                    <li>Cookies, web beacons, and similar tracking technologies</li>
                    <li>Third-party tools like Google Analytics, WhatsApp, Razorpay, etc.</li>
                </ul>
                <p><strong>3. How We Use Your Information</strong></p>
                <p>We use your information for the following purposes:</p>
                <ul type="disc">
                    <li>To deliver and fulfill services ordered by you</li>
                    <li>To communicate with you regarding your project</li>
                    <li>To provide account management and customer support</li>
                    <li>To process transactions and generate invoices</li>
                    <li>To customize and improve user experience</li>
                    <li>To send service updates, newsletters, or promotional content (opt-in only)</li>
                    <li>To comply with legal obligations and requests from law enforcement</li>
                    <li>To analyze Platform usage for performance, optimization, and troubleshooting</li>
                </ul>
                <p><strong>4. Legal Basis for Processing (GDPR Compliance)</strong></p>
                <p>If you are a user from the European Union, our legal basis for collecting and using personal data depends on the context and nature of the data:</p>
                <ul type="disc">
                    <li><strong>Performance of a Contract</strong>&nbsp;(e.g., to build your ecommerce store)</li>
                    <li><strong>Consent</strong>&nbsp;(e.g., for newsletters)</li>
                    <li><strong>Legal Obligation</strong>&nbsp;(e.g., tax reporting)</li>
                    <li><strong>Legitimate Interest</strong>&nbsp;(e.g., platform analytics and security)</li>
                </ul>
                <p><strong>5. How We Share Your Information</strong></p>
                <p>We do not sell your personal data. However, we may share it with:</p>
                <p><strong>5.1 Third-Party Service Providers</strong></p>
                <p>We may share limited data with trusted third parties for services like:</p>
                <ul type="disc">
                    <li>Web hosting and cloud storage</li>
                    <li>Email and communication tools</li>
                    <li>Payment processors (e.g., Razorpay, PayPal)</li>
                    <li>Analytics (e.g., Google Analytics)</li>
                    <li>Domain registrars and DNS providers</li>
                    <li>CDN and firewall providers (e.g., Cloudflare)</li>
                </ul>
                <p>All such third parties are contractually bound to protect your information.</p>
                <p><strong>5.2 Legal Authorities</strong></p>
                <p>We may disclose your data to governmental agencies or law enforcement if:</p>
                <ul type="disc">
                    <li>Required by law or legal process</li>
                    <li>Necessary to prevent fraud or cybercrime</li>
                    <li>Needed to protect the rights, property, or safety of Craft My Store, its clients, or others</li>
                </ul>
                <p><strong>6. Data Retention</strong></p>
                <p>We retain your data:</p>
                <ul type="disc">
                    <li>For as long as your account or project remains active</li>
                    <li>As required to fulfill legal, accounting, or reporting obligations</li>
                    <li>For a minimum of <strong>7 years</strong> for financial and transactional records (as per Indian law)</li>
                </ul>
                <p>You may request deletion of your data, subject to legal exceptions.</p>
                <p><strong>7. Data Security</strong></p>
                <p>We implement technical and organizational safeguards including:</p>
                <ul type="disc">
                    <li>SSL encryption</li>
                    <li>Secure password protocols</li>
                    <li>Firewall and DDoS protection</li>
                    <li>Restricted data access based on roles</li>
                    <li>Regular security patching and backups</li>
                </ul>
                <p>However, no system is entirely immune to risk. You agree to use the Platform at your own risk and notify us of any suspected data breach.</p>
                <p><strong>8. Cookies &amp; Tracking Technologies</strong></p>
                <p>We might use cookies and similar technologies to:</p>
                <ul type="disc">
                    <li>Remember your preferences</li>
                    <li>Authenticate sessions</li>
                    <li>Analyze traffic and site behavior</li>
                </ul>
                <p>You can control or delete cookies through your browser settings. Some parts of the Platform may not function properly if cookies are disabled.</p>
                <p><strong>9. Your Rights</strong></p>
                <p>Depending on your jurisdiction, you may have the following rights:</p>
                <p><strong>9.1 Under Indian Law (IT Act + SPDI Rules)</strong></p>
                <ul type="disc">
                    <li>Right to access and correct your information</li>
                    <li>Right to withdraw consent at any time</li>
                    <li>Right to grievance redressal</li>
                </ul>
                <p><strong>9.2 Under GDPR (EU Residents)</strong></p>
                <ul type="disc">
                    <li>Right to access, rectify, or erase personal data</li>
                    <li>Right to restrict or object to processing</li>
                    <li>Right to data portability</li>
                    <li>Right to withdraw consent</li>
                    <li>Right to file a complaint with a supervisory authority</li>
                </ul>
                <p>To exercise your rights, contact us at: <strong>contact@craftmystore.com</strong></p>
                <p><strong>10. Third-Party Links</strong></p>
                <p>Our Platform may contain links to third-party websites or services. We are not responsible for their privacy practices. Please read their policies before engaging with them.</p>
                <p><strong>11. Children's Privacy</strong></p>
                <p>Our Platform and Services are not intended for children under <strong>18 years of age</strong>. We do not knowingly collect personal data from minors. If we become aware that data from a child has been collected, we will delete it promptly.</p>
                <p><strong>12. Data Transfer Across Borders</strong></p>
                <p>If you are located outside India, please note that your data may be processed and stored in India or other countries with different data protection laws.</p>
                <p>By using our Platform, you consent to the transfer of your data to such jurisdictions.</p>
                <p><strong>13. Changes to this Privacy Policy</strong></p>
                <p>We may update this Policy from time to time. All changes will be posted on this page with the "Last Updated" date. You are advised to review this page periodically.</p>
                <p><strong>14. Grievance Redressal Officer (As per Indian Law)</strong></p>
                <p>In compliance with the <strong>Information Technology Act, 2000</strong>, for any grievance or complaint regarding the privacy policy, please contact us at contact@craftmystore.com</p>
                <p>We will acknowledge and address complaints within <strong>15 business days</strong>.</p>
                <p><strong>15. Contact Us</strong></p>
                <p>For any questions or concerns related to this Privacy Policy or your data, you may contact:</p>
                <p><strong>Craft My Store</strong><br />
                    <strong> Operated by: </strong>Teraforge Digital Lab LLP<br />
                    <strong> Email: </strong>contact@craftmystore.com<br />
                    <strong> Phone:</strong> +91 7718837352<br />
                    <strong> Website: </strong><a href="https://www.craftmystore.com" target="_blank" rel="noopener noreferrer">https://www.craftmystore.com</a><br />
                    <strong>Address: </strong>T6, Lodha Crown, Quality Homes Thane, Near Majiwada Flyover, Thane – 400601, Maharashtra, India
                </p>
                <p>&nbsp;</p>
            </div>

        </>

    );
};

export default PrivacyPolicy;